import { render, staticRenderFns } from "./DeskSelectDialog.vue?vue&type=template&id=74ad755c&scoped=true"
import script from "./DeskSelectDialog.vue?vue&type=script&lang=js"
export * from "./DeskSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./DeskSelectDialog.vue?vue&type=style&index=0&id=74ad755c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ad755c",
  null
  
)

export default component.exports